import $ from 'jquery';
window.$ = window.jQuery = $;

//NEST STEP SCRIPT
if ($(".article--js").length > 0) {
	$('.article--js').on("click", function (e) {
		e.preventDefault();
		var article = $(this).data("article-step");
		$(".article-order__step").removeClass("active");
		$(this).parents().find('.article-order__step[article-step="' + article + '"]').addClass("active");
	});
}